import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { mapState, media, toCurrency } from '@deerplusofficial/pos-helper';
import { Button } from '@deerplusofficial/pos-components';
import { withCheckout } from '../../model/Mutations';
import TabContent from './TabContent';
import CheckoutButton from './CheckoutButton';
import InfoSectionWrapper from '../Info/InfoSectionWrapper';
import InfoSectionPoints from '../Info/InfoSectionPoints';
import MemberActions from '../MemberActions/MemberActions';
import InfoSection from '../Info/InfoSection';
import Info from '../Info/Info';

const TagsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  align-items: flex-start;
  align-content: flex-start;
  margin-top: 16px;
  ${media(
    'tablet',
    css`
      margin-top: 28px;
      flex-grow: 1;
    `
  )};
`;

const Tag = styled(Button)`
  margin-bottom: 18px;
`;

class EtcTab extends React.PureComponent {
  static propTypes = {
    order: PropTypes.shape(),
    meta: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    order: {},
    meta: [],
  };

  state = {
    methodId: '',
  };

  onSubmit = () => {
    const { onCheckout } = this.props;
    const { methodId } = this.state;

    onCheckout({ methodId });
  };

  renderTags = () => {
    const { meta } = this.props;
    const { methodId } = this.state;

    return _.map(meta, ({ name, id }) => {
      const isActive = id === methodId;

      return (
        <Tag
          secondary
          icon={isActive && 'check'}
          highlight={isActive}
          key={id}
          onClick={() => this.setState({ methodId: id })}
        >
          {name}
        </Tag>
      );
    });
  };

  render() {
    const {
      order: { submitting, price, points },
    } = this.props;
    const { methodId } = this.state;

    return (
      <React.Fragment>
        <TabContent>
          <InfoSectionWrapper>
            <InfoSectionPoints />
            <InfoSection>
              <Info label="支付金額">{toCurrency(price - points)}</Info>
            </InfoSection>
            <MemberActions />
          </InfoSectionWrapper>
          <TagsContainer>{this.renderTags()}</TagsContainer>
        </TabContent>
        <CheckoutButton
          loading={submitting}
          onClick={this.onSubmit}
          disabled={!_.size(methodId)}
        />
      </React.Fragment>
    );
  }
}

export default fp.compose(
  withCheckout(),
  connect(mapState(['order']))
)(EtcTab);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/EtcTab.js